import React, { useState } from "react";
import { youtubeVideos } from "../../../Data/Data";
import SingleYoutube from "./SingleYoutube";
import Filter from "./Filter";

const Youtube = () => {
  const [activeVideo, setActiveVideo] = useState(
    "https://www.youtube.com/embed/HySH1Easuf4?si=v0O87X5_EtWJ1tIy"
  );

  const [youtubeData, setYoutubeData] = useState(youtubeVideos);
  return (
    <>
      <h2 className="text-lg py-[1.3rem]">Youtube Videos</h2>
      <div className="bg-box p-4">
        <p className="font-light text-darkText">
          Web development is my playground, and in my YouTube videos, I unveil the magic
          behind bringing ideas to life online. Every bit of code is like a brush stroke,
          creating websites that aren't just functional but look darn good too.
        </p>
        <Filter setYoutubeData={setYoutubeData} setActiveVideo={setActiveVideo} />
        <div className="pt-[1rem] flex flex-col lg:flex-row">
          <iframe
            className="w-full lg:w-[35rem] min-h-[20rem] flex-[1.2]"
            src={activeVideo}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen></iframe>

          <div className="max-h-[20rem] overflow-auto pl-0 pt-2 lg:pt-0 lg:pl-2 flex-[1] flex flex-col gap-2">
            {youtubeData.map((item) => (
              <SingleYoutube
                item={item}
                key={item.name}
                setActiveVideo={setActiveVideo}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Youtube;
